
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import {
  apiShopLists,
  apiOrderOrderGetOrderTransferTableChartsData,
  apiOrderOrderGetOrderTransferTableSettlementChartsData,
} from "@/api/shop";
import { copyClipboard } from "@/utils/util";
import * as echarts from "echarts";

@Component({
  components: {},
})
export default class OrderList extends Vue {
  searchObj: any = {
    shop_id: "",
  };
  shopList: any[] = [];

  orderTransferTableChartsData: any[] = [];

  orderTransferTableSettlementChartsData: any[] = [{}];

  loading: boolean = false;

  handleSearch() {
    this.getOrderTransferTableChartsData();
    this.getOrderOrderGetOrderTransferTableSettlementChartsData();
  }
  reset() {
    this.searchObj = {
      shop_id: "",
    };
    this.getOrderTransferTableChartsData();
    this.getOrderOrderGetOrderTransferTableSettlementChartsData();
  }

  getOrderOrderGetOrderTransferTableSettlementChartsData() {
    this.loading = true; // 开始加载状态
    apiOrderOrderGetOrderTransferTableSettlementChartsData({
      sid: this.searchObj.shop_id,
    }).then((res) => {
      const chartDom: any = document.getElementById("chartContainerId");
      if (chartDom) {
        const existingChart = echarts.getInstanceByDom(chartDom);
        if (existingChart) {
          existingChart.dispose(); // 销毁旧实例
        }
      }
      this.orderTransferTableSettlementChartsData = res;
      if (!res.length) return;
      console.log(
        "🚀 ~ OrderList ~ getOrderOrderGetOrderTransferTableSettlementChartsData ~ chartDom:",
        chartDom,
      );
      let myChart = echarts.init(chartDom);
      myChart.setOption({
        title: [
          {
            text: "转单待结算",
            top: 10,
            textStyle: {
              fontSize: 18,
            },
          },
          {
            subtext: "",
            top: 10,
            left: "center",
            clickable: true,
            triggerEvent: true,
          },
        ],
        xAxis: {
          type: "category",
          data: this.orderTransferTableSettlementChartsData.map(
            (item: any) => item.date,
          ),
        },
        yAxis: {
          type: "value",
        },
        itemStyle: {
          // 点的颜色。
          color: "red",
        },
        tooltip: {
          trigger: "axis",
        },
        series: [
          {
            name: "单数",
            data: this.orderTransferTableSettlementChartsData.map(
              (item: any) => item.count,
            ),
            type: "bar",
            smooth: true,
            itemStyle: {
              borderWidth: 2, // 增加边框宽度，进一步扩大点击区域
              borderColor: "transparent", // 透明边框不影响视觉
            },
            // 增强交互效果
            emphasis: {
              scale: true, // 鼠标悬停时放大
              focus: "series", // 高亮当前系列
            },
          },
          {
            name: "金额",
            data: this.orderTransferTableSettlementChartsData.map(
              (item: any) => item.money,
            ),
            type: "line",
            smooth: true,
            itemStyle: {
              borderWidth: 2, // 增加边框宽度，进一步扩大点击区域
              borderColor: "transparent", // 透明边框不影响视觉
            },
            // 增强交互效果
            emphasis: {
              scale: true, // 鼠标悬停时放大
              focus: "series", // 高亮当前系列
            },
          },
        ],
      });

      myChart.on("click", (params: any) => {
        console.log(params);
        let text = "";
        if (params.componentType === "title") {
          text = params.event.target.style.text;
        } else {
          text = params.value;
        }
        copyClipboard(text)
          .then(() => {
            this.$message.success("复制成功");
          })
          .catch((err) => {
            this.$message.error("复制失败");
            console.log(err);
          });
      });

      this.loading = false; // 请求完成，停止加载状态
    });
  }

  getOrderTransferTableChartsData() {
    this.loading = true; // 开始加载状态
    apiOrderOrderGetOrderTransferTableChartsData({
      sid: this.searchObj.shop_id,
    }).then((res) => {
      this.setChart(res, "orderTransferTableChartsData", "chartContainer");
      this.loading = false; // 请求完成，停止加载状态
    });
  }

  setChart(data: any, key: any, dom: any) {
    try {
      // 先清理所有旧的图表实例和事件监听器
      // @ts-ignore
      this[key].forEach((v: any, index: any) => {
        const chartDom = document.getElementById(dom + index);
        if (chartDom) {
          const existingChart = echarts.getInstanceByDom(chartDom);
          if (existingChart) {
            existingChart.dispose(); // 销毁旧实例
          }
        }
      });
      // @ts-ignore
      this[key] = data;
      this.$nextTick(() => {
        // @ts-ignore
        this[key].forEach((v: any, index: any) => {
          if (v.data && v.data.length > 0) {
            let chartDom = document.getElementById(
              "chartContainer" + index,
            ) as any;
            let myChart = echarts.init(chartDom);
            myChart.setOption({
              title: [
                {
                  text: v.title,
                  top: 10,
                  textStyle: {
                    fontSize: 18,
                  },
                },
              ],
              xAxis: {
                type: "category",
                data: v.data.map((item: any) => item.date),
              },
              yAxis: {
                type: "value",
              },
              itemStyle: {
                // 点的颜色。
                color: "red",
              },
              tooltip: {
                trigger: "axis",
              },
              series: [
                {
                  name: v.title,
                  data: v.data.map((item: any) => item.value),
                  type: "line",
                  smooth: true,
                  itemStyle: {
                    borderWidth: 2, // 增加边框宽度，进一步扩大点击区域
                    borderColor: "transparent", // 透明边框不影响视觉
                  },
                  // 增强交互效果
                  emphasis: {
                    scale: true, // 鼠标悬停时放大
                    focus: "series", // 高亮当前系列
                  },
                },
              ],
            });

            myChart.on("click", (params: any) => {
              console.log(params);
              let text = "";
              if (params.componentType === "title") {
                text = params.event.target.style.text;
              } else {
                text = params.value;
              }
              copyClipboard(text)
                .then(() => {
                  this.$message.success("复制成功");
                })
                .catch((err) => {
                  this.$message.error("复制失败");
                  console.log(err);
                });
            });
          }
        });
      });
    } catch (err) {
      console.log("err", err);
    }
  }

  async getShopList() {
    let res = await apiShopLists({ page_size: 9999 });
    this.shopList = res.lists;
  }
  async mounted() {
    await this.getShopList();
    this.getOrderTransferTableChartsData();
    this.getOrderOrderGetOrderTransferTableSettlementChartsData();
  }
}
